import React from 'react';

// Shared bar so every skeleton uses the same tone and shimmer.
const Bar = ({ className = '', tone = 'base' }) => (
  <div
    className={`shimmer rounded-md ${className}`}
    style={{ background: tone === 'strong' ? 'var(--ink-200)' : 'var(--ink-100)' }}
  />
);

export function SkeletonCard() {
  return (
    <div className="o-card p-4">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <Bar className="h-4 w-3/4 mb-2" tone="strong" />
          <Bar className="h-3 w-1/2" />
        </div>
        <Bar className="h-5 w-16 rounded-full" />
      </div>
      <div className="flex gap-3 mt-3">
        <Bar className="h-3 w-16" />
        <Bar className="h-3 w-12" />
        <Bar className="h-3 w-14" />
      </div>
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div className="o-card p-5">
      <Bar className="w-9 h-9 rounded-xl mb-4" />
      <Bar className="h-6 w-16 mb-2" tone="strong" />
      <Bar className="h-3 w-24" />
    </div>
  );
}

export function SkeletonTable({ rows = 5 }) {
  return (
    <div className="o-card overflow-hidden">
      <div className="h-10" style={{ background: 'var(--ink-50)', borderBottom: '1px solid var(--line)' }} />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 px-5 py-3.5" style={{ borderBottom: '1px solid var(--ink-100)' }}>
          <Bar className="h-4 flex-1" />
          <Bar className="h-4 w-20" />
          <Bar className="h-4 w-16" />
          <Bar className="h-4 w-12" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div className="p-6 space-y-5">
      <Bar className="h-7 w-48" tone="strong" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1,2,3,4].map(i => <SkeletonStat key={i} />)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <SkeletonTable rows={4} />
        <SkeletonTable rows={4} />
      </div>
    </div>
  );
}

export function SkeletonClients() {
  return (
    <div className="p-6 space-y-4">
      <div className="flex justify-between items-center">
        <Bar className="h-7 w-32" tone="strong" />
        <Bar className="h-9 w-28 rounded-xl" />
      </div>
      <Bar className="h-10 w-full rounded-xl" />
      <div className="hidden md:block"><SkeletonTable rows={6} /></div>
      <div className="md:hidden space-y-3">
        {[1,2,3,4,5].map(i => <SkeletonCard key={i} />)}
      </div>
    </div>
  );
}
